const specialStyle = (curDocStyle, initStyle) => {
    return (initStyle *  curDocStyle) / 1080;
}
export {
    specialStyle
}